var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2092_57386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.056 49.7428H0.0556641V55.2028H106.056V49.7428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 44.2828H0.0556641V49.7428H106.056V44.2828Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 38.8228H0.0556641V44.2828H106.056V38.8228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 55.2028H0.0556641V60.6628H106.056V55.2028Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 66.1328H0.0556641V71.5928H106.056V66.1328Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 60.6728H0.0556641V66.1328H106.056V60.6728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 6.05278H0.0556641V11.5128H106.056V6.05278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 0.592773H0.0556641V6.05277H106.056V0.592773Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 11.5128H0.0556641V16.9728H106.056V11.5128Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 22.4428H0.0556641V27.9028H106.056V22.4428Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 16.9828H0.0556641V22.4428H106.056V16.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 27.9028H0.0556641V33.3628H106.056V27.9028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 33.3628H0.0556641V38.8228H106.056V33.3628Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9757 0.592773H0.0556641V38.8228H53.9757V0.592773Z",
    fill: "#002965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 2.41278L5.04578 3.94278H6.65578L5.35578 4.89278L5.85578 6.43278L4.54578 5.48278L3.23578 6.43278L3.73578 4.89278L2.42578 3.94278H4.04578L4.54578 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 2.41278L49.986 3.94278H51.596L50.296 4.89278L50.796 6.43278L49.486 5.48278L48.176 6.43278L48.676 4.89278L47.376 3.94278H48.986L49.486 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 2.41278L40.9957 3.94278H42.6157L41.3057 4.89278L41.8057 6.43278L40.4957 5.48278L39.1857 6.43278L39.6857 4.89278L38.3857 3.94278H39.9957L40.4957 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 2.41278L32.0055 3.94278H33.6255L32.3155 4.89278L32.8155 6.43278L31.5055 5.48278L30.2055 6.43278L30.7055 4.89278L29.3955 3.94278H31.0155L31.5055 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 2.41278L23.0262 3.94278H24.6362L23.3263 4.89278L23.8263 6.43278L22.5262 5.48278L21.2162 6.43278L21.7162 4.89278L20.4062 3.94278H22.0262L22.5262 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 2.41278L14.036 3.94278H15.646L14.346 4.89278L14.836 6.43278L13.536 5.48278L12.226 6.43278L12.726 4.89278L11.416 3.94278H13.036L13.536 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 10.0528L5.04578 11.5928H6.65578L5.35578 12.5428L5.85578 14.0728L4.54578 13.1228L3.23578 14.0728L3.73578 12.5428L2.42578 11.5928H4.04578L4.54578 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 10.0528L49.986 11.5928H51.596L50.296 12.5428L50.796 14.0728L49.486 13.1228L48.176 14.0728L48.676 12.5428L47.376 11.5928H48.986L49.486 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 10.0528L40.9957 11.5928H42.6157L41.3057 12.5428L41.8057 14.0728L40.4957 13.1228L39.1857 14.0728L39.6857 12.5428L38.3857 11.5928H39.9957L40.4957 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 10.0528L32.0055 11.5928H33.6255L32.3155 12.5428L32.8155 14.0728L31.5055 13.1228L30.2055 14.0728L30.7055 12.5428L29.3955 11.5928H31.0155L31.5055 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 10.0528L23.0262 11.5928H24.6362L23.3263 12.5428L23.8263 14.0728L22.5262 13.1228L21.2162 14.0728L21.7162 12.5428L20.4062 11.5928H22.0262L22.5262 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 10.0528L14.036 11.5928H15.646L14.346 12.5428L14.836 14.0728L13.536 13.1228L12.226 14.0728L12.726 12.5428L11.416 11.5928H13.036L13.536 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 17.6928L5.04578 19.2328H6.65578L5.35578 20.1828L5.85578 21.7228L4.54578 20.7728L3.23578 21.7228L3.73578 20.1828L2.42578 19.2328H4.04578L4.54578 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 17.6928L49.986 19.2328H51.596L50.296 20.1828L50.796 21.7228L49.486 20.7728L48.176 21.7228L48.676 20.1828L47.376 19.2328H48.986L49.486 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 17.6928L40.9957 19.2328H42.6157L41.3057 20.1828L41.8057 21.7228L40.4957 20.7728L39.1857 21.7228L39.6857 20.1828L38.3857 19.2328H39.9957L40.4957 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 17.6928L32.0055 19.2328H33.6255L32.3155 20.1828L32.8155 21.7228L31.5055 20.7728L30.2055 21.7228L30.7055 20.1828L29.3955 19.2328H31.0155L31.5055 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 17.6928L23.0262 19.2328H24.6362L23.3263 20.1828L23.8263 21.7228L22.5262 20.7728L21.2162 21.7228L21.7162 20.1828L20.4062 19.2328H22.0262L22.5262 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 17.6928L14.036 19.2328H15.646L14.346 20.1828L14.836 21.7228L13.536 20.7728L12.226 21.7228L12.726 20.1828L11.416 19.2328H13.036L13.536 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 25.3428L5.04578 26.8728H6.65578L5.35578 27.8228L5.85578 29.3628L4.54578 28.4128L3.23578 29.3628L3.73578 27.8228L2.42578 26.8728H4.04578L4.54578 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 25.3428L49.986 26.8728H51.596L50.296 27.8228L50.796 29.3628L49.486 28.4128L48.176 29.3628L48.676 27.8228L47.376 26.8728H48.986L49.486 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 25.3428L40.9957 26.8728H42.6157L41.3057 27.8228L41.8057 29.3628L40.4957 28.4128L39.1857 29.3628L39.6857 27.8228L38.3857 26.8728H39.9957L40.4957 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 25.3428L32.0055 26.8728H33.6255L32.3155 27.8228L32.8155 29.3628L31.5055 28.4128L30.2055 29.3628L30.7055 27.8228L29.3955 26.8728H31.0155L31.5055 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 25.3428L23.0262 26.8728H24.6362L23.3263 27.8228L23.8263 29.3628L22.5262 28.4128L21.2162 29.3628L21.7162 27.8228L20.4062 26.8728H22.0262L22.5262 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 25.3428L14.036 26.8728H15.646L14.346 27.8228L14.836 29.3628L13.536 28.4128L12.226 29.3628L12.726 27.8228L11.416 26.8728H13.036L13.536 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 32.9828L5.04578 34.5228H6.65578L5.35578 35.4728L5.85578 37.0028L4.54578 36.0528L3.23578 37.0028L3.73578 35.4728L2.42578 34.5228H4.04578L4.54578 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 32.9828L49.986 34.5228H51.596L50.296 35.4728L50.796 37.0028L49.486 36.0528L48.176 37.0028L48.676 35.4728L47.376 34.5228H48.986L49.486 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 32.9828L40.9957 34.5228H42.6157L41.3057 35.4728L41.8057 37.0028L40.4957 36.0528L39.1857 37.0028L39.6857 35.4728L38.3857 34.5228H39.9957L40.4957 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 32.9828L32.0055 34.5228H33.6255L32.3155 35.4728L32.8155 37.0028L31.5055 36.0528L30.2055 37.0028L30.7055 35.4728L29.3955 34.5228H31.0155L31.5055 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 32.9828L23.0262 34.5228H24.6362L23.3263 35.4728L23.8263 37.0028L22.5262 36.0528L21.2162 37.0028L21.7162 35.4728L20.4062 34.5228H22.0262L22.5262 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 32.9828L14.036 34.5228H15.646L14.346 35.4728L14.836 37.0028L13.536 36.0528L12.226 37.0028L12.726 35.4728L11.416 34.5228H13.036L13.536 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 29.1628L45.496 30.7028H47.106L45.796 31.6528L46.296 33.1828L44.996 32.2328L43.686 33.1828L44.186 31.6528L42.876 30.7028H44.496L44.996 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 29.1628L36.5057 30.7028H38.1157L36.8157 31.6528L37.3157 33.1828L36.0057 32.2328L34.6957 33.1828L35.1957 31.6528L33.8857 30.7028H35.5057L36.0057 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 29.1628L27.5155 30.7028H29.1255L27.8255 31.6528L28.3255 33.1828L27.0155 32.2328L25.7055 33.1828L26.2055 31.6528L24.8955 30.7028H26.5155L27.0155 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 29.1628L18.526 30.7028H20.146L18.836 31.6528L19.336 33.1828L18.026 32.2328L16.716 33.1828L17.216 31.6528L15.916 30.7028H17.526L18.026 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 29.1628L9.53578 30.7028H11.1558L9.84578 31.6528L10.3458 33.1828L9.03578 32.2328L7.73578 33.1828L8.23578 31.6528L6.92578 30.7028H8.54578L9.03578 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 21.5228L45.496 23.0528H47.106L45.796 24.0028L46.296 25.5428L44.996 24.5928L43.686 25.5428L44.186 24.0028L42.876 23.0528H44.496L44.996 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 21.5228L36.5057 23.0528H38.1157L36.8157 24.0028L37.3157 25.5428L36.0057 24.5928L34.6957 25.5428L35.1957 24.0028L33.8857 23.0528H35.5057L36.0057 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 21.5228L27.5155 23.0528H29.1255L27.8255 24.0028L28.3255 25.5428L27.0155 24.5928L25.7055 25.5428L26.2055 24.0028L24.8955 23.0528H26.5155L27.0155 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 21.5228L18.526 23.0528H20.146L18.836 24.0028L19.336 25.5428L18.026 24.5928L16.716 25.5428L17.216 24.0028L15.916 23.0528H17.526L18.026 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 21.5228L9.53578 23.0528H11.1558L9.84578 24.0028L10.3458 25.5428L9.03578 24.5928L7.73578 25.5428L8.23578 24.0028L6.92578 23.0528H8.54578L9.03578 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 13.8728L45.496 15.4128H47.106L45.796 16.3628L46.296 17.9028L44.996 16.9528L43.686 17.9028L44.186 16.3628L42.876 15.4128H44.496L44.996 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 13.8728L36.5057 15.4128H38.1157L36.8157 16.3628L37.3157 17.9028L36.0057 16.9528L34.6957 17.9028L35.1957 16.3628L33.8857 15.4128H35.5057L36.0057 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 13.8728L27.5155 15.4128H29.1255L27.8255 16.3628L28.3255 17.9028L27.0155 16.9528L25.7055 17.9028L26.2055 16.3628L24.8955 15.4128H26.5155L27.0155 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 13.8728L18.526 15.4128H20.146L18.836 16.3628L19.336 17.9028L18.026 16.9528L16.716 17.9028L17.216 16.3628L15.916 15.4128H17.526L18.026 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 13.8728L9.53578 15.4128H11.1558L9.84578 16.3628L10.3458 17.9028L9.03578 16.9528L7.73578 17.9028L8.23578 16.3628L6.92578 15.4128H8.54578L9.03578 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 6.23279L45.496 7.77279H47.106L45.796 8.72279L46.296 10.2528L44.996 9.30279L43.686 10.2528L44.186 8.72279L42.876 7.77279H44.496L44.996 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 6.23279L36.5057 7.77279H38.1157L36.8157 8.72279L37.3157 10.2528L36.0057 9.30279L34.6957 10.2528L35.1957 8.72279L33.8857 7.77279H35.5057L36.0057 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 6.23279L27.5155 7.77279H29.1255L27.8255 8.72279L28.3255 10.2528L27.0155 9.30279L25.7055 10.2528L26.2055 8.72279L24.8955 7.77279H26.5155L27.0155 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 6.23279L18.526 7.77279H20.146L18.836 8.72279L19.336 10.2528L18.026 9.30279L16.716 10.2528L17.216 8.72279L15.916 7.77279H17.526L18.026 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 6.23279L9.53578 7.77279H11.1558L9.84578 8.72279L10.3458 10.2528L9.03578 9.30279L7.73578 10.2528L8.23578 8.72279L6.92578 7.77279H8.54578L9.03578 6.23279Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2092_57386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0557 36.5928C78.0557 50.3977 66.8666 61.5928 53.0557 61.5928C51.3788 61.5928 49.7325 61.4281 48.1471 61.1111C36.6898 58.8306 28.0557 48.7208 28.0557 36.5928C28.0557 22.7818 39.2508 11.5928 53.0557 11.5928C66.8605 11.5928 77.3788 22.1172 78.0252 35.3489C78.0435 35.7574 78.0557 36.1781 78.0557 36.5928Z",
    fill: "#44C4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9156 47.4037H61.501L62.312 26.2574H66.1046L66.9156 47.4037Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7691 47.4037H50.3545L51.1655 26.2574H54.9582L55.7691 47.4037Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6226 47.4037H39.208L40.019 26.2574H43.8117L44.6226 47.4037Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.501 29.1781V30.3915C61.501 30.6294 61.69 30.8184 61.9278 30.8184H66.4888C66.7266 30.8184 66.9156 30.6294 66.9156 30.3915V29.1781H61.501Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3545 29.1781V30.3915C50.3545 30.6294 50.5435 30.8184 50.7813 30.8184H55.3423C55.5801 30.8184 55.7691 30.6294 55.7691 30.3915V29.1781H50.3545Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.208 29.1781V30.3915C39.208 30.6294 39.397 30.8184 39.6348 30.8184H44.1958C44.4336 30.8184 44.6226 30.6294 44.6226 30.3915V29.1781H39.208Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6655 44.9647H38.2021C37.7753 44.9647 37.4277 45.3123 37.4277 45.7391V47.1964H68.4399V45.7391C68.4399 45.3123 68.0924 44.9647 67.6655 44.9647Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8848 47.1903H36.9824C36.5556 47.1903 36.208 47.5379 36.208 47.9647V49.0745C36.208 49.2635 36.3604 49.4159 36.5495 49.4159H69.3178C69.5068 49.4159 69.6592 49.2635 69.6592 49.0745V47.9647C69.6592 47.5379 69.3117 47.1903 68.8848 47.1903Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5673 25.8854L53.482 18.6355C53.2198 18.5074 52.9149 18.5074 52.6527 18.6355L37.5612 25.8854C37.232 26.044 37.0186 26.3794 37.0186 26.7513V28.2513C37.0186 28.7818 37.4454 29.2086 37.9759 29.2086H68.1527C68.6832 29.2086 69.11 28.7818 69.11 28.2513V26.7513C69.11 26.3854 68.8966 26.044 68.5673 25.8854Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.043 27.0684L53.0613 20.8123L66.0796 27.0684H40.043Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8847 25.3672V24.3123C52.5555 24.2208 52.3176 24.0745 52.1652 23.8855C52.0128 23.6964 51.9335 23.4647 51.9335 23.1964C51.9335 22.9281 52.0189 22.6903 52.1957 22.5074C52.3664 22.3184 52.5981 22.2147 52.8847 22.1842V21.9342H53.2506V22.1842C53.5189 22.2147 53.7262 22.3062 53.8847 22.4586C54.0433 22.6111 54.1408 22.8062 54.1835 23.0623L53.5494 23.1477C53.5128 22.9525 53.4091 22.8184 53.2506 22.7452V23.7269C53.653 23.8367 53.9274 23.9769 54.0737 24.1476C54.2201 24.3184 54.2933 24.544 54.2933 24.8123C54.2933 25.1172 54.2018 25.3733 54.0189 25.5806C53.8359 25.7879 53.5798 25.9159 53.2567 25.9647V26.4342H52.8908V25.9769C52.6042 25.9403 52.3664 25.8367 52.1835 25.6537C52.0006 25.4708 51.8847 25.2147 51.8359 24.8855L52.4884 24.8123C52.5128 24.9464 52.5676 25.0623 52.6408 25.1598C52.714 25.2574 52.7994 25.3245 52.8847 25.3733V25.3672ZM52.8847 22.733C52.7872 22.7635 52.7079 22.8245 52.6469 22.9037C52.5859 22.983 52.5615 23.0745 52.5615 23.172C52.5615 23.2635 52.5859 23.3428 52.6408 23.422C52.6957 23.4952 52.775 23.5623 52.8847 23.605V22.7391V22.733ZM53.2506 25.4037C53.3786 25.3794 53.4762 25.3245 53.5554 25.2269C53.6347 25.1355 53.6713 25.0257 53.6713 24.8976C53.6713 24.7879 53.6408 24.6903 53.5737 24.605C53.5067 24.5257 53.3969 24.4586 53.2506 24.4159V25.3976V25.4037Z",
    fill: "#EBF0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2092_57386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 71,
    fill: "white",
    transform: "translate(0.0556641 0.592773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2092_57386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(28.0557 11.5928)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlf);
export default __webpack_public_path__ + "static/media/XLF.1c918a933691408262e6099f52235e2b.svg";
export { ForwardRef as ReactComponent };